import { getHandler } from 'src/utils/fetchHandler';

export const GET_ACTIVITY_TYPES = 'GET_ACTIVITY_TYPES/ACTIVITY_TYPES/@WISELY/WEB';
export const FETCH_ACTIVITY_TYPES_SUCCEEDED =
	'FETCH_ACTIVITY_TYPES_SUCCEEDED/ACTIVITY_TYPES/@WISELY/WEB';
export const FETCH_ACTIVITY_TYPES_FAILED = 'FETCH_ACTIVITY_TYPES_FAILED/ACTIVITY_TYPES/@WISELY/WEB';

export const getActivityTypes = () => ({
	type: GET_ACTIVITY_TYPES,
});

export const fetchActivityTypesSucceeded = payload => ({
	type: FETCH_ACTIVITY_TYPES_SUCCEEDED,
	payload,
});

export const fetchActivityTypesFailed = payload => ({
	type: FETCH_ACTIVITY_TYPES_FAILED,
	payload,
});

export const fetchActivityTypes = () => {
	return dispatch => {
		dispatch(getActivityTypes());
		const path = `v2/activity_types`;

		return getHandler(path)
			.then(json => dispatch(fetchActivityTypesSucceeded(json)))
			.catch(error => {
				console.error('fetchActivityTypes error', error);
				dispatch(fetchActivityTypesFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/activityTypes/activityType.action.js